import React, { memo, useMemo } from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  TEAM_CHAT_AVATAR_DEFAULT_SIZE,
  TEAM_CHAT_AVATAR_SMALL_THRESHOLD,
} from './TeamChatMemberAvatar.constants';
import {
  getAvatarStyles,
  getOfflineBadgeStyles,
  getOnlineBadgeStyles,
  getWrapperStyles,
} from './TeamChatMemberAvatar.styles';
import { getMemberColor, getMemberInitials } from './TeamChatMemberAvatar.utils';

const TeamChatMemberAvatar = memo(
  ({ member, isOnline = false, showPresence = true, size = TEAM_CHAT_AVATAR_DEFAULT_SIZE }) => {
    const initials = getMemberInitials(member);
    const color = getMemberColor(member);
    const initialsVariant = size < TEAM_CHAT_AVATAR_SMALL_THRESHOLD ? 'medium10' : 'medium12';

    const wrapperStyles = useMemo(() => getWrapperStyles({ size }), [size]);
    const avatarStyles = useMemo(() => getAvatarStyles({ size, color }), [size, color]);
    const badgeStyles = useMemo(
      () => (isOnline ? getOnlineBadgeStyles({ size }) : getOfflineBadgeStyles({ size })),
      [isOnline, size],
    );

    return (
      <Box sx={wrapperStyles}>
        <Avatar sx={avatarStyles}>
          <Typography color="text.secondary" variant={initialsVariant}>
            {initials}
          </Typography>
        </Avatar>
        {showPresence && <Box sx={badgeStyles} />}
      </Box>
    );
  },
);
TeamChatMemberAvatar.propTypes = {
  member: PropTypes.object.isRequired,
  isOnline: PropTypes.bool,
  showPresence: PropTypes.bool,
  size: PropTypes.number,
};

export default TeamChatMemberAvatar;
